import _extends from "@babel/runtime/helpers/esm/extends";
var _svg, _IconLoading;
// Modules
import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Typography from "../../atoms/Typography";
import { IconLoading } from "../../atoms/Icon";

// Styles
import colors from "../../theme/colors";

// Types
import Container from "../../atoms/Container";
import DLCCard from "../../molecules/DLCCard";
import useInfiniteScroll from 'react-infinite-scroll-hook';
import ModalSelectPlatform from "../EStoreProductDetailDownloadable/ModalSelectPlatform";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ScrollingDLCContainer = props => {
  const {
    title,
    productList,
    hasNextPage,
    onLoadMore,
    onClickBuy,
    titleBack,
    titleModalSelectPlatform,
    titleButtonBuyNowDigital,
    onBack
  } = props;
  const loading = null;
  const [showModalPlatform, setShowModalPlatform] = useState(false);
  const [itemBuy, setItemBuy] = useState({});
  const refTimeOut = useRef();
  useEffect(() => {
    return () => {
      window.clearTimeout(refTimeOut.current);
    };
  }, []);
  const handleLoadMore = () => {
    refTimeOut.current = setTimeout(() => {
      onLoadMore?.();
    }, 500);
  };
  const [infiniteRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore: handleLoadMore,
    rootMargin: '0px 0px 200px 0px'
  });
  const Icon = _svg || (_svg = /*#__PURE__*/_jsx("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.8418 12.1587L14.3996 19.8095C14.759 20.2288 15.3903 20.2774 15.8097 19.918C16.229 19.5585 16.2776 18.9272 15.9181 18.5079L10.476 12.1587L15.9181 5.8095C16.2776 5.39018 16.229 4.75888 15.8097 4.39945C15.3903 4.04003 14.759 4.08859 14.3996 4.50792L7.8418 12.1587Z",
      fill: "#1E1E1E"
    })
  }));
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      padding: {
        xs: "72px 0px",
        md: "80px 0px"
      }
    },
    children: [/*#__PURE__*/_jsxs(Container, {
      sx: {
        display: "flex",
        flexDirection: "column"
      },
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: {
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          width: "fit-content",
          cursor: "pointer",
          paddingBottom: {
            xs: "28px",
            md: "40px"
          },
          "& svg": {
            '&:hover': {
              '& path': {
                stroke: colors.primary.bandaiNamcoBlack
              }
            }
          }
        },
        onClick: () => onBack?.(),
        children: [Icon, /*#__PURE__*/_jsx(Typography, {
          variant: "p7",
          sx: {
            marginLeft: "6px",
            width: "fit-content",
            position: "relative",
            lineHeight: "19px",
            "&::before": {
              position: "absolute",
              content: "''",
              left: "0px",
              bottom: "-3px",
              width: "100%",
              border: "8px",
              borderBottom: `2px solid ${colors.primary.bandaiNamcoBlack}`
            }
          },
          children: titleBack
        })]
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          width: "100%",
          display: "flex",
          flexDirection: "column"
        },
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          sx: {
            marginBottom: {
              xs: "28px",
              md: "40px"
            }
          },
          children: title
        }), /*#__PURE__*/_jsx(Box, {
          sx: {
            display: "flex",
            flexFlow: "wrap",
            gap: {
              xs: "104px 22px",
              md: "82px 22px"
            }
          },
          children: !!productList?.length && productList?.map((item, index) => {
            return /*#__PURE__*/_jsx(Box, {
              sx: {
                width: {
                  xs: "100%",
                  md: "calc((100% / 2) - 12px)",
                  lg: "calc((100% / 3) - 16px)"
                },
                maxWidth: {
                  xs: "100%",
                  md: "calc((100% / 2) - 12px)",
                  lg: "calc((100% / 3) - 16px)"
                }
              },
              children: /*#__PURE__*/_jsx(DLCCard, _extends({}, item, {
                onClickBuy: () => {
                  setItemBuy(item);
                  setShowModalPlatform(true);
                }
              }))
            }, index);
          })
        }), hasNextPage && /*#__PURE__*/_jsx(Box, {
          ref: infiniteRef,
          sx: {
            marginTop: {
              xs: '72px',
              md: '110px',
              display: 'flex',
              justifyContent: 'center'
            }
          },
          children: _IconLoading || (_IconLoading = /*#__PURE__*/_jsx(IconLoading, {}))
        })]
      })]
    }), /*#__PURE__*/_jsx(ModalSelectPlatform, {
      open: showModalPlatform,
      onClose: () => setShowModalPlatform(false),
      titleModalSelectPlatform: titleModalSelectPlatform,
      listPlatform: itemBuy?.platformList,
      titleButtonBuy: titleButtonBuyNowDigital,
      onClickBuy: value => onClickBuy?.(_extends({
        id: itemBuy?.id
      }, value))
    })]
  });
};
export default ScrollingDLCContainer;